import { render } from "./index.vue?vue&type=template&id=1791ae8d&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1791ae8d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1791ae8d"

export default script